// extracted by mini-css-extract-plugin
export default {"attributes-container":"UploadAttributes_attributes-container__ylW3D","title":"UploadAttributes_title__h33ph","hint":"UploadAttributes_hint__AoLsn"};